var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Award = function Award(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 9a7 7 0 1 1 13.337 2.977l3.127 5.415a1 1 0 0 1-.93 1.498l-2.933-.189-1.303 2.634a1 1 0 0 1-1.762.057L12 17l-2.536 4.392a1 1 0 0 1-1.762-.056L6.399 18.7l-2.933.19a1 1 0 0 1-.93-1.499l3.127-5.415A6.973 6.973 0 0 1 5 9Zm7-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-5.086 9.81-1.712 2.964 1.734-.112a1 1 0 0 1 .96.555l.77 1.557 1.711-2.963a6.993 6.993 0 0 1-3.463-2.002Zm6.709 2a6.993 6.993 0 0 0 3.463-2l1.712 2.964-1.734-.112a1 1 0 0 0-.96.555l-.77 1.557-1.711-2.963Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Award;